<template>
  <div class="face-collect" data-test="face-collect">

    <div class="main">
      <div class="face-logo"></div>
      <h2 class="main-title">上传人脸照片</h2>
      <div class="tips">用于签到时识别学员</div>
      <div class="top">

        <van-uploader 
          v-show="!facePhoto" 
          class="btn-wrap" 
          ref="uploader"
          result-type="file" 
          upload-icon=""
          :after-read="addImg">
        </van-uploader>

        <!-- @click="prevFacePho(facePhoto)" -->
        <div
          v-if="facePhoto"
          class="ph"
          :style="`background-image: url('${facePhoto}');`"
          data-test="face-collect-btn-re-upload"
          @click="reUpload"
        >
          <div class="btn-del" @click.stop="delFacePho" data-test="face-collect-btn-delete">
            <svg class="vxm-icon" aria-hidden="true" font-size="16">
              <use xlink:href="#vxm-icon-shanchu"></use>
            </svg>
          </div>
          <div class="btn-tips" >
            <van-icon name="replay" />点击重新上传
          </div>
        </div>
      </div>

      <div class="tip">
        <div class="text">上传须知</div>
        <img class="img" src="https://cdn01.xiaogj.com/uploads/x3/assets/m/img/teacher/app-face-001.png?t=123456" alt="" />
      </div>
    </div>
    <div class="footer">
      <div class="btn-sub">
        <van-button type="primary" block square round @click="updateFace" data-test="face-collect-btn-confirm">
          确定
        </van-button>
      </div>
      <div class="notify-line" @click="$router.push('/face/notification')" v-if="app.permission.op('face_in')">
        <span class="link" >通知采集面部信息</span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      stuId: this.$vxRoute.params.id,
      facePhoto: '',
      pageTitle: "编辑学员信息"
    };
  },
  methods: {
    async addImg(res, detail) {
      vant.Toast.loading({
        message: '加载中...',
        forbidClick: true,
        loadingType: 'spinner',
        overlay: true,
        duration: 0,
      });

      let ret = await xgjzt.oss.uploadFile({
        platform: 'h5',
          options: {
            file: res.file,
          },
      });
      this.facePhoto = ret.url;
      vant.Toast.clear();
    },
    // prevFacePho(url) {
    //   vant.ImagePreview([url]);
    // },
    delFacePho() {
      this.facePhoto = '';
    },
    reUpload () {
      console.log(this.$refs["uploader"])
      this.$refs["uploader"] && this.$refs["uploader"].chooseFile();
    },
    async updateFace() {
      this.showLoading();
      let res = await this.$api.updateFaceStudent({
        id: this.stuId,
        companyId: app.teacher.user.companyId,
        facePhoto: this.facePhoto,
      });

      if (res.code == 200) {
        vant.Toast.success('操作成功');
        app.vue.$emit('updateStudentFaceSuccess');
        app.vue.$emit('studentInfoRefresh');
        app.vue.$emit('studentDeatilRefresh');
        this.$router.back();
      } else {
        vant.Toast.fail(res.msg);
      }
    },
  },
  async created() {
    if (this.stuId) {   
      let res = await this.$api.getContainFace({ id: this.stuId });
      if (res.data.studentFaceList.length > 0) {
        this.facePhoto = res.data.studentFaceList[0].faceUrl;
      }
    }
  },
};
</script>

<style lang="scss" scoped>
.face-collect{
  background: var(--white);
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}
.main{
  flex: 1;
  overflow-y: auto;
}
.face-logo{
  margin: calc(var(--gap) * 19)  calc(var(--gap) * 16) calc(var(--gap) * 7);
  width: calc(var(--w) * 61);
  height: calc(var(--w) * 24);
  background: transparent url(https://cdn01.xiaogj.com/uploads/x3/assets/m/img/teacher/app-face-002.png) center/cover no-repeat;
}
.top {
  padding: calc(var(--gap) * 16);
  background: var(--white);
  .tx {
    padding: calc(var(--gap) * 8) 0 calc(var(--gap) * 16);
    font-size: var(--fs-md);
    line-height: var(--lh-md);
    font-weight: 400;
    color: var(--g6);
  }
  .btn-wrap {
    position: relative;
    display: block;
    margin: calc(var(--gap) * 20) auto calc(var(--gap) * 36);
    width: calc(var(--w) * 140);
    height: calc(var(--w) * 140);    
    background: transparent url(https://cdn01.xiaogj.com/uploads/x3/assets/m/img/teacher/app-face-003.png) center/cover no-repeat;


    ::v-deep .van-uploader__upload,
    ::v-deep .van-uploader__input{

      width: calc(var(--w) * 140);
      height: calc(var(--w) * 140);   
      background-color: transparent;
    }
  }
  .ph {
    position: relative;
    margin: calc(var(--gap) * 20) auto calc(var(--gap) * 36);
    width: calc(var(--w) * 140);
    height: calc(var(--w) * 140); 
    background-size: cover;
    background-repeat: no-repeat;
    background-position: center;
  }
  .btn-del {
    position: absolute;
    width: calc(var(--w) * 30);
    height: calc(var(--w) * 30);
    display: flex;
    justify-content: center;
    align-items: center;
    right: calc(var(--w) * -15);
    top: calc(var(--w) * -15);
  }
  .btn-tips {
    position: absolute;
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    right: 0;
    bottom: 0;
    background-color: rgba(0, 0, 0, 0.7);
    color: var(--white);
    font-size:var(--fs-md);
    line-height:var(--lh-md);
    >i{
      // transform: rotateZ(15deg);
      margin-right: calc(var(--gap) * 2);
    }
  }
}
.main-title{
  margin: calc(var(--gap) * 7) 0 0;
  padding: 0 calc(var(--gap) * 16);
  font-size: calc(var(--fs-ex2)*1.3);
  line-height: calc(var(--lh-ex2)*1.3);
  font-weight: 500;
}
.tips{
  padding: 0 calc(var(--gap) * 16);
  color: var(--g6);
}
.tip {
  padding: calc(var(--gap) * 24);
  .text {
    font-size: var(--fs-lg);
    line-height: var(--lh-lg);
    font-weight: var(--bold);
    color: var(--g8);
  }
  .img {
    margin-top: calc(var(--gap) * 16);
    width: 100%;
  }
}
.footer{ 
  margin-bottom: calc(var(--gap) * 32);
}
.btn-sub {
  margin: 0 0 calc(var(--gap) * 12);
  padding: 0 calc(var(--gap) * 16);
}
.notify-line{
  text-align: center;
  .link {
    color: var(--c1);
  }
}
</style>